import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const {
  HRM: { PROMOTION },
} = ROUTES;

export const TableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      id: 1,
      key: "PromotionName",
      name: t("PROMOTION_LIST.TABLE.COLUMN.NAME"),
      render: (groupName: string) => <Text color="subtitle1">{groupName}</Text>,
    },
    {
      id: 2,
      key: "totalCandidates",
      name: t("PROMOTION_LIST.TABLE.COLUMN.TOTAL_CANDIDATES"),
      render: (totalCandidates: number) => (
        <Text color="subtitle1">{totalCandidates}</Text>
      ),
    },
    {
      id: 3,
      key: "status",
      name: t("PROMOTION_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 4,
      key: "nextReviewer",
      name: t("PROMOTION_LIST.TABLE.COLUMN.FILE_ON_HAND"),
      render: (nextReviewer: EmployeeCommonInfoType) => {
        return nextReviewer?.id !== null ? (
          <ProfileInfoCard employee={nextReviewer} />
        ) : (
          <></>
        );
      },
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: string) => <ViewButton link={`${PROMOTION}/${id}`} />,
    },
  ];
};
